// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/examples.js with go/sail-next-tailor-docs-publisher 

import { ButtonExamples } from './Button';
import { LinkExamples } from './Link';
import { DrawerExamples } from './Drawer';
import { MenuExamples } from './Menu';
import { PopoverExamples } from './Popover';
import { BadgeExamples } from './Badge';
import { CounterExamples } from './Counter';
import { ListExamples } from './List';
import { CheckboxExamples } from './checkbox';
import { TextareaExamples } from './textarea';
import { TextFieldExamples } from './textfield';
import { SelectExamples } from './select';
import { RadioExamples } from './radio';
import { SwitchExamples } from './switch';
import { DividerExamples } from './Divider'; // NOTE: These tailor component examples are copied to the external
// stripe docs for Tailor UI Toolkit via http://go/sail-next-tailor-docs-publisher

export const tailorComponentExamples = {
  Button: ButtonExamples,
  Link: LinkExamples,
  Menu: MenuExamples,
  Badge: BadgeExamples,
  Counter: CounterExamples,
  List: ListExamples,
  Checkbox: CheckboxExamples,
  TextArea: TextareaExamples,
  Select: SelectExamples,
  TextField: TextFieldExamples,
  Radio: RadioExamples,
  Switch: SwitchExamples,
  Divider: DividerExamples
};
export const componentToExamples = { ...tailorComponentExamples,
  Drawer: DrawerExamples,
  Popover: PopoverExamples
};